/**
 * The IANA time zone of this browser (e.g. "America/New_York"), or undefined
 * when the platform will not say. Sent when a meeting is booked so the
 * invitation can show the start time in the organiser's zone (row bec6d137).
 */
export function browserTimeZone(): string | undefined {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof tz === "string" && tz ? tz : undefined;
  } catch {
    return undefined;
  }
}
